import styled from "styled-components";
import {tokens} from "../../../theme";

export const PageNavigationWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;
    padding: 12px 16px;
    background: ${({theme}) => theme.palette.background.paper};
    border-radius: 8px;
`;

export const PageInfo = styled.div`
    font-size: ${tokens.fontSize.sm};
    font-weight: ${tokens.fontWeight.medium};
    color: ${({theme}) => theme.palette.text.secondary};
    min-width: 100px;
    text-align: center;
`;

export const NavButton = styled.button<{ disabled?: boolean }>`
    display: flex;
    align-items: center;
    justify-content: center;
    
    width: 32px;
    height: 32px;
    
    border-radius: ${tokens.radius.sm};
    border: 1px solid ${({theme}) => theme.palette.dividers.subtle};
    background: ${({theme}) => theme.palette.background.paper};
    
    color: ${({disabled, theme}) => disabled 
            ? theme.palette.text.disabled
            : theme.palette.text.primary
    };
    
    transition: all 0.2s;
    
    font-size: ${tokens.fontSize.lg};
    cursor: pointer;
    
    &:hover {
        background: ${({disabled, theme}) => disabled
                ? theme.palette.background.paper
                : theme.palette.background.default
        };
    }

    &:active {
        transform: ${({disabled}) => disabled ? 'none' : 'scale(0.95)'};
    }
`;